import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Badkern „Technische Daten“ (29.09.2026).
 * Gewicht (und EAN) sind Variantenwerte. Horizon morpht beim Variantenwechsel nur den
 * Variant-Picker; dieser Block übernimmt seinen neuen Inhalt aus dem productSelect-Event
 * (Muster: product-inventory.js / auswahl-verfuegbarkeit.js). Gelauscht wird auf dem
 * Dokument, weil der Block im Tab-Bereich liegt und nicht zwingend in derselben Sektion
 * wie der Variant-Picker.
 */
class TechnischeDaten extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /** @param {any} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const { html, newProduct } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }
        const neu = html.querySelector('technische-daten');
        if (!neu) return;
        morph(this, neu, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[technische-daten] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('technische-daten')) {
  customElements.define('technische-daten', TechnischeDaten);
}
